// Webpack Imports
import * as bootstrap from 'bootstrap';

//import { gsap } from "gsap/dist/gsap";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
//https://greensock.com/docs/v3/Plugins/ScrollToPlugin
gsap.registerPlugin(ScrollToPlugin);





(function () {  // It’s an Immediately-Invoked Function Expression, or IIFE for short. It executes immediately after it’s created. http://benalman.com/news/2010/11/immediately-invoked-function-expression/
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});

	//**ScrollTo with GSAP */

	// Detect if a link's href goes to the current page
	function getSamePageAnchor(link) {
		if (
			link.protocol !== window.location.protocol ||
			link.host !== window.location.host ||
			link.pathname !== window.location.pathname ||
			link.search !== window.location.search
		) {
			return false;
		}

		return link.hash;
	}

	// Scroll to a given hash, preventing the event given if there is one
	function scrollToHash(hash, e) {
		const elem = hash ? document.querySelector(hash) : false;
		if (elem) {
			if (e) e.preventDefault();
			gsap.to(window, { duration: 1, scrollTo: elem, ease: "power2.out" });
		}
	}

	// If a link's href is within the current page, scroll to it instead
	document.querySelectorAll('a[href]').forEach(a => {
		a.addEventListener('click', e => {
			scrollToHash(getSamePageAnchor(a), e);
		});
	});

	// Scroll to the element in the URL's hash on load
	scrollToHash(window.location.hash);


})();
/*
jQuery(document).ready(function(){
	jQuery("#scrolltotest").click(function(){
	  gsap.to(window, {duration: 2, scrollTo: "#work_projects"});
	  //gsap.to(window, {duration: 2, scrollTo: 400});
	});
});*/


/** JSDoc 
 *  JSDoc ist eine Auszeichnungssprache, mit der JavaScript-Quellcodedateien mit Anmerkungen versehen werden. Mithilfe von Kommentaren, die JSDoc enthalten, können Programmierer eine Dokumentation hinzufügen, die die Anwendungsprogrammierschnittstelle des von ihnen erstellten Codes beschreibt. 
 * */